// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumBadge-cls1_ihY","cls2":"PremiumBadge-cls2_bmt PremiumBadge-cls1_ihY"};